module.exports = __webpack_public_path__ + "img/credit-card-providers.8d52d65.webp";